import { gql } from '@apollo/client';

export const VALIDATE_ACCOUNT = gql`
  query Query($accountNumber: String) {
    customerAccountWebsite(accountNumber: $accountNumber) {
      id
      accountId
      fuel
      utilityAddress {
        state
      }
      dormant
      paymentMethod
    }
  }
`;
